var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentConfig?.component)?_c(_vm.currentConfig.component,_vm._g(_vm._b({key:_vm.redirectionConfig.ack_id,tag:"component",staticClass:"max-h-full",on:{"submit":_vm.submitScreen,"cancel":function($event){return _vm.$emit('cancel')},"error":_vm.onError}},'component',_vm.currentConfig.props,false),_vm.currentConfig.listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }